var map = {
	"./alert.svg": 5543,
	"./artsy.svg": 6368,
	"./certificate.svg": 6590,
	"./check.svg": 9345,
	"./chevron.svg": 6162,
	"./date.svg": 5262,
	"./email.svg": 5426,
	"./export.svg": 1756,
	"./facebook.svg": 150,
	"./favorite.svg": 3384,
	"./hide.svg": 4095,
	"./instagram.svg": 4121,
	"./linkedin.svg": 5933,
	"./location.svg": 928,
	"./original.svg": 6353,
	"./person.svg": 7704,
	"./phone.svg": 3268,
	"./quote.svg": 8722,
	"./right-arrow.svg": 3385,
	"./send.svg": 9463,
	"./share.svg": 2867,
	"./show.svg": 4466,
	"./time.svg": 6776,
	"./twitter.svg": 1365,
	"./webatvantage.svg": 1613,
	"./x.svg": 2643,
	"./youtube.svg": 4401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4683;